export const welcomingText = 'Selamat Datang di Siglive! 👋';
export const projectDescriptionText = 'Kelola proyek live streaming dengan mudah dan tanpa ribet! Silakan login untuk melanjutkan.';
export const forgetPasswordText = 'Lupa Password?';
export const loadingAlert = { title: 'Harap tunggu', desc: 'Sedang melakukan login!' };
export const successAlert = { title: 'Success', desc: 'Berhasil melakukan login' };
export const errorAlert = { title: 'Error', desc: 'Gagal melakukan login!' };
export const errorDefaultText = 'Error Login!';
